let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5qdGq")).then(() => parcelRequire('3ZI7S'));